import { Component, OnInit } from '@angular/core';
import { EnvService } from '../_servicos/env.service';

@Component({
  selector: 'app-configuracoes',
  templateUrl: './configuracoes.component.html',
  styleUrls: ['./configuracoes.component.scss'],
})
export class ConfiguracoesComponent implements OnInit {
  notificacoesMostrar: boolean;

  constructor(private _env: EnvService) {
    this.notificacoesMostrar = this._env.notificacoesMostrando;
  }

  ngOnInit(): void {}

  alterar() {
    this._env.notificacoesMostrando = !this._env.notificacoesMostrando;
    //this.notificacoesMostrar = this._env.notificacoesMostrando;
  }
}
